import gql from "graphql-tag";

const CREATE_DRIVER = gql`
  mutation createDriver($driver: DriverInput!) {
    createDriver(driver: $driver)
  }
`;

export default CREATE_DRIVER;
